import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://sdsipeldbfhinfobingp.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNkc2lwZWxkYmZoaW5mb2JpbmdwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk4NDMyODgsImV4cCI6MjA5NTQxOTI4OH0.vJ6CfzS9sOT9cNfQP8qWsbayfA2dTj37dFQBv8NlQTM";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  },
});

export type ProfileRow = {
  id: string;
  full_name: string;
  email: string;
  phone: string | null;
  role: "borrower" | "admin" | "super_admin" | "manager";
  is_active: boolean;
  email_verified: boolean;
  avatar_url: string | null;
  created_at: string;
  updated_at: string;
};
